import { render, staticRenderFns } from "./FullLayout.vue?vue&type=template&id=58c81888&scoped=true"
import script from "./FullLayout.vue?vue&type=script&lang=js"
export * from "./FullLayout.vue?vue&type=script&lang=js"
import style0 from "./FullLayout.vue?vue&type=style&index=0&id=58c81888&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c81888",
  null
  
)

export default component.exports